export default {
    buscando: false,
    items: [],
    selecionado: {},
    usuario: {},
    // tarefas: {},
    // regionais: [],
    // contatos: [],
    // equipes: [],
    // configuracao: [],
}